export default __webpack_public_path__ + "static/media/header-work.3ce22cf6.jpg";